<div class="platform-page-container">
  <div class="platform-header-container">
    <markant-platform-registration-header [loginButton]="true">
    </markant-platform-registration-header>
  </div>

  <div class="platform-main">
    <div class="platform-content-container">
      <div class="platform-content">
        <ng-container *transloco="let t; loadingTpl: loading">
          <div class="left-container-error-page flex-row-centered">
            <div class="container-content-error-page flex-col-start">
              <h2 class="left-container-title-error-page">
                {{ t('auth.loginFailed.' + errorType + '.headline') }}
              </h2>
              <p>
                {{ t('auth.loginFailed.' + errorType + '.message') }}
              </p>
              <markant-button
                colorScheme="primary"
                (click)="openContactSupportDialog()"
                (keydown.enter)="openContactSupportDialog()"
              >
                {{ t('auth.contactSupport') }}
              </markant-button>
            </div>
          </div>
          <div class="right-container-error-page">
            <img
              alt="Error login"
              loading="lazy"
              [src]="'assets/images/login/background-error-login.png'"
            />
          </div>
        </ng-container>
        <ng-template #loading>
          <div class="left-container-error-page flex-row-centered">
            <div class="container-content-error-page flex-col-start">
              <markant-skeleton-screen
                loading="true"
                animation="pulse"
                autoAdjustment="false"
                width="300"
                height="24"
              />
              <markant-skeleton-screen
                loading="true"
                animation="pulse"
                width="400"
                height="16"
              />
              <markant-skeleton-screen
                loading="true"
                animation="pulse"
                width="250"
                height="16"
              />
              <markant-skeleton-screen
                loading="true"
                animation="pulse"
                width="150"
                height="48"
              />
            </div>
          </div>
          <div class="right-container-error-page">
            <img
              alt="Error login"
              [src]="'assets/images/login/background-error-login.png'"
            />
          </div>
        </ng-template>
      </div>

      <div class="platform-footer">
        <markant-platform-footer [isPublic]="true"></markant-platform-footer>
      </div>
    </div>
  </div>
</div>

@if (isDialogOpen) {
  <markant-dialog
    class="dialog"
    [critical]="true"
    [open]="isDialogOpen"
    (close)="closeContactSupportDialog()"
  >
    @if (formSent) {
      <div class="success-container">
        <h3 class="dialog-title">
          {{ 'auth.contactSupportDialog.title' | transloco }}
        </h3>
        <p class="dialog-description">
          {{ 'auth.contactSupportDialog.description' | transloco }}
        </p>
        <div class="success-image-container">
          <img
            alt="Success contact form"
            loading="lazy"
            [fill]="true"
            [ngSrc]="'assets/images/login/successContactForm.svg'"
          />
        </div>
      </div>
      <div class="dialog-support-button-container flex-row-end">
        <markant-button
          id="dialog-close-button"
          colorScheme="primary"
          data-cy="dialog-close-button"
          (click)="completeContactSupportDialog()"
          (keydown.enter)="completeContactSupportDialog()"
        >
          {{ 'common.close' | transloco }}
        </markant-button>
      </div>
    } @else {
      <h3 class="dialog-title">
        {{ 'auth.contactOurSupportTeam' | transloco }}
      </h3>
      <markant-platform-support-form-error
        [formGroup]="loginErrorForm"
        [loading]="loadingButton"
        (cancel)="closeContactSupportDialog()"
        (submitForm)="saveContactSupport()"
      ></markant-platform-support-form-error>
    }
  </markant-dialog>
}
